namespace TabAurous.JobWork {

    @Serenity.Decorators.registerEditor()
    export class JobWorkOrderTypeEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);


            this.addOption("1", "Order");
            this.addOption("2", "Stock");
            

        }
    }
}